import { FC, memo } from "react";
import { Chip } from "@mui/material";
import { TConfigItemType } from "../../models";
import { FIELD_TYPE_LABELS } from "./helpers";

export const FieldTypeChip: FC<{ type: TConfigItemType }> = memo(({ type }) => (
  <Chip label={FIELD_TYPE_LABELS[type] ?? type} size='small' variant='outlined' />
));
